export const roleTypes = {
  ADMINISTRATOR: 'admin',
  USER: 'user',
  TENANT_ADMIN: 'tenant-admin',
}
